// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   Audit Logs Specific Styles
================================ */

/* Filters group layout */
.audit-filters-group {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  flex: 1 1;
}

/* Loading overlay */
.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 1rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 0.9rem;
  color: var(--muted, #6b7280);
  z-index: 10;
}

/* Compact changes display */
.changes-compact {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.82rem;
}

.change-line {
  color: #4b5563;
  white-space: nowrap;
}

/* Badge variants for actions */
.badge--warning {
  background: rgba(251, 191, 36, 0.12);
  color: #92400e;
}

.badge--info {
  background: rgba(59, 130, 246, 0.12);
  color: #1e40af;
}

.badge--primary {
  background: rgba(99, 102, 241, 0.12);
  color: #4338ca;
}

.badge--success {
  background: rgba(34, 197, 94, 0.12);
  color: #15803d;
}

.badge--secondary {
  background: rgba(148, 163, 184, 0.12);
  color: #475569;
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .audit-filters-group {
    flex-direction: column;
    width: 100%;
  }

  .audit-filters-group .select-wrap {
    width: 100%;
  }

  .audit-filters-group .select {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/AuditLogs.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC,yBAAyB;AACzB;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,SAAO;AACT;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ================================\n   Audit Logs Specific Styles\n================================ */\n\n/* Filters group layout */\n.audit-filters-group {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  flex: 1;\n}\n\n/* Loading overlay */\n.loading-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 1rem 2rem;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 0.9rem;\n  color: var(--muted, #6b7280);\n  z-index: 10;\n}\n\n/* Compact changes display */\n.changes-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.82rem;\n}\n\n.change-line {\n  color: #4b5563;\n  white-space: nowrap;\n}\n\n/* Badge variants for actions */\n.badge--warning {\n  background: rgba(251, 191, 36, 0.12);\n  color: #92400e;\n}\n\n.badge--info {\n  background: rgba(59, 130, 246, 0.12);\n  color: #1e40af;\n}\n\n.badge--primary {\n  background: rgba(99, 102, 241, 0.12);\n  color: #4338ca;\n}\n\n.badge--success {\n  background: rgba(34, 197, 94, 0.12);\n  color: #15803d;\n}\n\n.badge--secondary {\n  background: rgba(148, 163, 184, 0.12);\n  color: #475569;\n}\n\n/* Responsive adjustments */\n@media (max-width: 900px) {\n  .audit-filters-group {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .audit-filters-group .select-wrap {\n    width: 100%;\n  }\n\n  .audit-filters-group .select {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
